import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import Context from './Context';
import Rdx from '../redux/Rdx';
import SelectPolicyActions from '../components/PolicyActions/SelectPolicyActions';
import SuitabilityModeler from '../components/SuitabilityModeler/SuitabilityModeler';
import Topic from './Topic';
import { WroContext } from '../components/SuitabilityModeler/wro/wro-context'
import * as wroColormaps from '../components/SuitabilityModeler/wro/wro-colormaps'

import "@esri/calcite-components/dist/components/calcite-button";
import "@esri/calcite-components/dist/components/calcite-icon";
import "@esri/calcite-components/dist/components/calcite-slider";
import {
  CalciteButton,
  CalciteIcon,
  CalciteSlider
} from "@esri/calcite-components-react";

import * as esriNS from "@arcgis/core/kernel"

export default class Bridge {

  Topic = Topic

  esri3id;
  idModule;

  _paPalettes = [];
  _paUpdateRoot;
  _paUpdateRootNode;

  _wroRoot;
  _wroRootNode;

  constructor() {
    this._listen();
  }

  async _initIdModule() {
    if (!this.idModule) {
      this.idModule = await import("./id")
    }
  }

  async _marshallV3Credentials(esri3id) {
    await this._initIdModule();
    if (this.idModule) this.idModule.marshallV3Credentials(esri3id);
  }

  _listen() {

    console.log("Bridge.esriNS.version",esriNS.version);

    // Topic.subscribe(Topic.Test1, (params: any) => {
    //   const node = document.createElement("div");
    //   document.body.appendChild(node);
    //   const root = createRoot(node);

    //   const content = (
    //     <div className="right-panel weighted-overlay slide in from-right">
    //       <div className="panel gp-panel has-header">
    //         <div className="panel-heading">
    //           <h3 className="panel-title">react-panel</h3>
    //           <span className="esri-icon-close btn-icon" title="Close"
    //             onClick={() => {
    //               if (node && node.parentNode) {
    //                 node.parentNode.removeChild(node);
    //                 root.unmount();
    //               }
    //             }}
    //           ></span>
    //         </div>
    //         <div className="panel-body" style={{padding: "10px"}}>
    //           <div style={{marginTop: "10px"}}>
    //             <CalciteButton type="button" 
    //               onClick={() => {
    //                 console.log("calcite-button clicked")
    //               }}
    //             >calcite-button</CalciteButton>
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   )

    //   root.render(
    //     <React.StrictMode>
    //       <Provider store={Rdx.store}>
    //         {content}
    //       </Provider>
    //     </React.StrictMode>
    //   );
    // })

    // Topic.subscribe(Topic.Test2, (params: any) => {
    //   const content = (
    //     <span><span>react-element</span></span>
    //   );
    //   const root = createRoot(params.domNode);
    //   root.render(
    //     <React.StrictMode>
    //       <Provider store={Rdx.store}>
    //         {content}
    //       </Provider>
    //     </React.StrictMode>
    //   );
    // })


    Topic.subscribe(Topic.PolicyActions_DestroyPalette, (params: any) => {
      this.destroyPolicyActions("palette",params);
    })

    Topic.subscribe(Topic.PolicyActions_DestroyUpdate, (params: any) => {
      this.destroyPolicyActions("update",params);
    })

    Topic.subscribe(Topic.PolicyActions_ShowPalette, (params: any) => {
      this.showPolicyActions("palette",params);
    })

    Topic.subscribe(Topic.PolicyActions_ShowUpdate, (params: any) => {
      this.showPolicyActions("update",params);
    })

    Topic.subscribe(Topic.WroModeler_Destroy, (params: any) => {
      this.destroyWroModeler(params);
    })

    Topic.subscribe(Topic.WroModeler_Show, async (params: any) => {
      await this._marshallV3Credentials(this.esri3id);
      this.showWroModeler(params);
    })

    Topic.subscribe(Topic.PolicyActions_ShowModalSelect, (params: any) => {
      SelectPolicyActions.showModal(params);
    })

  }

  nls = (id: string, values?: any): string => {
    const getVal = (object, path) => {
      return path.split('.').reduce ((res, prop) => res[prop], object)
    }

    let v
    if (id && id.startsWith('wro_')) {
      id = 'suitabilityModeler.'+id;
    }
    if (id) {
      v = getVal(Context.instance.i18n,id);
    }
    if (values && typeof v === "string") {
      Object.keys(values).forEach(key => {
        const value = values[key];
        v = v.replace('{'+key+'}',value);
      })
    }
    //console.log("nls.id",id,v)
    return v;
    /*
    if (this.props.intl) {
      return this.props.intl.formatMessage({
        id: id,
        defaultMessage: defaultMessages[id]
      }, values)
    }
    */
    return id
  }

  destroyPolicyActions = (type, params?) => {
    if (type === "palette") {
      this._paPalettes.forEach(p => {
        this.destroyRoot(p.root,p.node)
      })
      this._paPalettes = [];
    } else if (type === "update") {
      this.destroyRoot(this._paUpdateRoot,this._paUpdateRootNode)
      this._paUpdateRoot = this._paUpdateRootNode = null;
    }
  }

  destroyRoot = async (root?,rootNode?) => {
    try {
      if (root) root.unmount()
     } catch(ex) {
       console.error(ex)
     }
     try {
      if (rootNode) rootNode.parentNode.removeChild(rootNode)
     } catch(ex) {
       console.error(ex)
     }
  }

  destroyWroModeler = async (params?) => {
    try {
      if (this._wroRoot) this._wroRoot.unmount()
     } catch(ex) {
       console.error(ex)
     }
     this._wroRoot = null
     try {
      if (this._wroRootNode) this._wroRootNode.parentNode.removeChild(this._wroRootNode)
     } catch(ex) {
       console.error(ex)
     }
     this._wroRootNode = null
  }

  showPolicyActions = (type,params) => {
    if (type !== "palette") this.destroyPolicyActions(type);
    const node = document.createElement("div");
    node.classList.add("g-policy-action-palette");
    params.parentNode.style.flex = "1 1 auto";
    params.parentNode.style.height = "100%";
    params.parentNode.style.overflow = "auto";
    params.parentNode.appendChild(node);
    try {
      let root = createRoot(node);
      if (type === "palette") {
        this._paPalettes.push({
          root: root,
          node: node
        })
      } else if (type === "update") {
        this.destroyRoot(this._paUpdateRoot,this._paUpdateRootNode)
        this._paUpdateRoot = root;
        this._paUpdateRootNode = node;
      }
      root.render(
        <React.StrictMode>
          <Provider store={Rdx.store}>
            <SelectPolicyActions {...params}
              onChange={(primaryId,delimitedIds,paletteInfo) => {
                if (typeof params.onSelectionChange === "function") {
                  params.onSelectionChange(primaryId,delimitedIds,paletteInfo);
                }
              }}
            />
          </Provider>
        </React.StrictMode>
      );
    } catch(ex) {
      console.error(ex)
    }
  }

  showWroModeler = async (params) => {
    const serviceUrl = params?.layer?.url;
    this.destroyWroModeler();
    const node = document.createElement("div");
    node.classList.add('widget-wro-container');
    params.parentNode.appendChild(node);

    wroColormaps.initLabels(this.nls)
    const wroContext = new WroContext()
    wroContext.nls = this.nls;
    wroContext.getConfig = (): any => {return {}}
    wroContext.getId = (): string => {if (true) throw new Error('wroContext.getId not supported')}
    wroContext.getLabel = (): string => null
    wroContext.getPortal = (): any => {if (true) throw new Error('wroContext.getPortal not supported')}
    wroContext.getPortalUrl = (): string => {if (true) throw new Error('wroContext.getPortalUrl not supported')}
    wroContext.getTheme = (): any => null
    wroContext.getUser = (): any => null
    wroContext.i18n = Context.instance.i18n;
    wroContext.layer = params.layer;

    try {
      const wroModel = await wroContext.loadModel(serviceUrl, null)
      //console.log("wroModel",wroModel)
      let root = this._wroRoot = createRoot(node);
      this._wroRootNode = node;
      root.render(
        <React.StrictMode>
          <Provider store={Rdx.store}>
            <SuitabilityModeler layer={params.layer} wroContext={wroContext} wroModel={wroModel} />
          </Provider>
        </React.StrictMode>
      );
    } catch(ex) {
      console.error(ex)
    }
  }

}